import styled, { css } from 'styled-components';
import { GenericSpan } from '../../common/Styles';
import { ASSET_PATH } from '../../../assetsPath';

export const OrangeBorder = styled.div(
	({ theme: { down, breakpoints } }) => `
		border-radius: 18px;
		background: #F76162;
		margin-bottom: 15px;
		width: 52px;
		height: 10px;
		${down(breakpoints.md)} {
			width: 30px; 
			height: 6px;
			margin-bottom: 10px;
			margin-left: 16px;
		}
	`
);

export const MyBizBlogSubTitle = styled.p(
	({ theme: { down, breakpoints } }) => `
		margin-bottom: 32px;
		width: 35%;
		font-size: 16px;
		${down(breakpoints.tb)} {
		}
		${down(breakpoints.md)} {
			padding: 0 16px;
			width: 100%;
			font-size: 14px;
			margin-bottom: 36px;
		}
`
);

export const PartnerIcons = styled(GenericSpan) `
    background: url(${ASSET_PATH.IMAGES}resource/logoSprite.png) no-repeat;
    display: inline-block;
		background-size: 600px 400px;
		font-size: 0px;
		flex-shrink: 0;
    ${(props) => {
		switch (props.icon) {
			case 'logoPnG': {
				return css`
					background-position: -10px -20px;
					width: 55px;
					height: 24px;
				`;
			}
			case 'logoBridgestone': {
				return css`
					background-position: -80px -16px;
					width: 190px;
					height: 24px;
				`;
			}
			case 'logoBlackberry': {
				return css`
					background-position: -283px -15px;
					width: 68px;
					height: 24px;
				`;
			}
			case 'logoBiba': {
				return css`
					background-position: -370px -20px;
					width: 98px;
					height: 25px;
				`;
			}
			case 'logoBajajFinserv': {
				return css`
					background-position: -480px -20px;
					width: 91px;
					height: 24px;
				`;
			}
			case 'logoIffco': {
				return css`
					background-position: -13px -58px;
					width: 60px;
					height: 24px;
				`;
			}
			case 'logoBajajConsumer': {
				return css`
					background-position: -85px -57px;
					width: 110px;
					height: 24px;
				`;
			}
			case 'logoAkzoNobel': {
				return css`
					background-position: -211px -59px;
					width: 126px;
					height: 24px;
			`;
			}
			case 'logoNetflix': {
				return css`
					background-position: -370px -55px;
					width: 90px;
					height: 24px;
			`;
			}
			case 'logoManyavar': {
				return css`
					background-position: -476px -55px;
					width: 74px;
					height: 24px;
			`;
			}
			case 'logoBurgerKing': {
				return css`
					background-position: -561px -55px;
					width: 24px;
					height: 24px;
			`;
			}
			case 'logoLodha': {
				return css`
					background-position: -12px -95px;
					width: 90px;
					height: 24px;
			`;
			}
			case 'logoLalPathLabs': {
				return css`
					background-position: -115px -95px;
					width: 109px;
					height: 24px;
			`;
			}
			case 'logoJockey': {
				return css`
					background-position: -237px -95px;
					width: 94px;
					height: 24px;
			`;
			}
			case 'logoIsc': {
				return css`
					background-position: -346px -94px;
					width: 47px;
					height: 24px;
			`;
			}
			case 'logoInfoEdge': {
				return css`
					background-position: -410px -94px;
					width: 94px;
					height: 24px;
			`;
			}
			case 'logoGodrej': {
				return css`
					background-position: -528px -93px;
					width: 50px;
					height: 24px;
			`;
			}
			case 'logoExtraMarks': {
				return css`
					background-position: -15px -128px;
					width: 50px;
					height: 24px;
			`;
			}
			case 'logoByjus': {
				return css`
					background-position: -79px -135px;
					width: 85px;
					height: 24px;
			`;
			}
			case 'logoZomato': {
				return css`
					background-position: -176px -134px;
					width: 112px;
					height: 24px;
			`;
			}
			case 'logoTeamComputers': {
				return css`
					background-position: -297px -131px;
					width: 58px;
					height: 24px;
			`;
			}
			case 'logoStorz': {
				return css`
					background-position: -372px -130px;
					width: 70px;
					height: 24px;
			`;
			}
			case 'logoVidalHealth': {
				return css`
					background-position: -445px -130px;
					width: 122px;
					height: 24px;
			`;
			}
			case 'logoSbiCard': {
				return css`
					background-position: -14px -170px;
					width: 127px;
					height: 24px;
			`;
			}
			case 'logoRailVikas': {
				return css`
					background-position: -158px -170px;
					width: 106px;
					height: 24px;
			`;
			}
			case 'logoPnBHousing': {
				return css`
					background-position: -279px -171px;
					width: 80px;
					height: 24px;
			`;
			}
			case 'logoPaySense': {
				return css`
					background-position: -369px -172px;
					width: 72px;
					height: 24px;
			`;
			}
			case 'logoCentaur': {
				return css`
					background-position: -452px -170px;
					width: 52px;
					height: 25px;
			`;
			}
			case 'logoAcko': {
				return css`
					background-position: -519px -170px;
					width: 42px;
					height: 24px;
			`;
			}
			case 'logoApollo': {
				return css`
					background-position: -15px -205px;
					width: 67px;
					height: 24px;
			`;
			}
			case 'logoHarsco': {
				return css`
					background-position: -96px -206px;
					width: 224px;
					height: 24px;
			`;
			}
			case 'logoTechMahindra': {
				return css`
					background-position: -331px -205px;
					width: 85px;
					height: 24px;
			`;
			}
			case 'logoTroikaa': {
				return css`
					background-position: -430px -205px;
					width: 56px;
					height: 24px;
			`;
			}
			case 'logoSleepwell': {
				return css`
					background-position: -503px -204px;
					width: 74px;
					height: 24px;
			`;
			}
			case 'logoRoyalCanin': {
				return css`
					background-position: -15px -235px;
					width: 61px;
					height: 24px;
			`;
			}
			case 'logoPonPure': {
				return css`
					background-position: -88px -242px;
					width: 90px;
					height: 24px;
			`;
			}
			case 'logoNandos': {
				return css`
					background-position: -193px -241px;
					width: 73px;
					height: 24px;
			`;
			}
			case 'logoNahar': {
				return css`
					background-position: -280px -241px;
					width: 54px;
					height: 24px;
			`;
			}
			case 'logoNaaptol': {
				return css`
					background-position: -345px -240px;
					width: 55px;
					height: 24px;
			`;
			}
			case 'logoMuthoot': {
				return css`
					background-position: -413px -240px;
					width: 32px;
					height: 24px;
			`;
			}
			case 'logoMetropolis': {
				return css`
					background-position: -457px -240px;
					width: 68px;
					height: 24px;
			`;
			}
			case 'logoMcDonalds': {
				return css`
					background-position: -547px -239px;
					width: 36px;
					height: 24px;
			`;
			}
			case 'logoFleetGuard': {
				return css`
					background-position: -416px -310px;
					width: 58px;
					height: 23px;
			`;
			}
			case 'logoEverest': {
				return css`
					background-position: -250px -276px;
					width: 64px;
					height: 24px;
			`;
			}
			case 'logoCremica': {
				return css`
					background-position: -323px -279px;
					width: 60px;
					height: 24px;
			`;
			}
			case 'logoColorJet': {
				return css`
					background-position: -395px -275px;
					width: 141px;
					height: 24px;
			`;
			}
			case 'logoCera': {
				return css`
					background-position: -353px -312px;
					width: 46px;
					height: 24px;
			`;
			}
			case 'logoLifeCell': {
				return css`
					background-position: -58px -271px;
					width: 106px;
					height: 25px;
			`;
			}
			case 'logoMalabar': {
				return css`
					background-position: -131px -301px;
					width: 84px;
					height: 24px;
			`;
			}
			case 'logoRazorpay': {
				return css`
					background-position: -8px -299px;
					width: 114px;
					height: 24px;
			`;
			}
			case 'logoHdb': {
				return css`
					background-position: -222px -310px;
					width: 120px;
					height: 24px;
			`;
			}
			default:
				break;
		}
	}}
`;
